import { createApp, type Component, reactive } from "vue";
import { extend, useExpose } from "../composables/use-expose";

export const mountComponent = (RootComponent: Component) => {
  const app = createApp(RootComponent);
  const root = document.createElement("div");

  document.body.appendChild(root);

  return {
    instance: app.mount(root),
    unmount () {
      app.unmount();
      document.body.removeChild(root);
    },
  };
};

export const usePopupState = () => {
  const state = reactive<{
    visible: boolean;
    [key: string]: any;
  }>({
    visible: true,
  });
  const toggle = (visible: boolean) => {
    state.visible = visible;
  };

  const open = (props: Record<string, any>) => {
    console.log('open', props)
    extend(state, props);
    console.log('open state', state)
    toggle(true);
  };
  const close = () => {
    toggle(false);
  };
  useExpose({ open, close, toggle });
  return {
    state,
    open,
    close,
    toggle,
  };
};
